import { render, staticRenderFns } from "./AmmeterChangeRecord.vue?vue&type=template&id=521bb1da&scoped=true&"
import script from "./AmmeterChangeRecord.vue?vue&type=script&lang=js&"
export * from "./AmmeterChangeRecord.vue?vue&type=script&lang=js&"
import style0 from "./AmmeterChangeRecord.vue?vue&type=style&index=0&id=521bb1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521bb1da",
  null
  
)

export default component.exports